import { useFollowActions } from '@/src/listings/components/OrganizerCard/hooks/useFollowActions';
import { redirectToSignIn } from '@/src/listings/utils/utils';
import type { FollowAction } from '../types';
import { FOLLOW_ACTION } from '../types';
import { track } from '@eventbrite/legacy-infra.datalayer-library';
import { LISTING_HEAP_IDS } from '@/src/listings/components/_shared/constants';
import { useStage } from '@/src/listings/hooks/useStage';
import { useOrganizerFollowStatus } from '@/src/listings/components/_shared/contexts/FollowOrganizerContext';

export const useFollowButtonActions = (organizerId: string, isAuthenticated: boolean) => {
  const { follow, unfollow, followActionLoading } = useFollowActions();
  const { updateFollowStatus, updateNumFollowers, numFollowers } = useOrganizerFollowStatus();
  const stage = useStage();

  const handleFollowAction = async (action: FollowAction, pageArea?: string) => {
    trackFollowAction(action, organizerId, pageArea);

    if (action === FOLLOW_ACTION && !isAuthenticated) {
      redirectToSignIn(organizerId, stage);
      return;
    }

    try {
      const result = action === FOLLOW_ACTION ? await follow(organizerId) : await unfollow(organizerId);

      if (result.success) {
        const newIsFollowing = action === FOLLOW_ACTION;
        const newNumFollowers = result.numFollowers ?? (action === FOLLOW_ACTION ? numFollowers + 1 : numFollowers - 1);
        updateFollowStatus(newIsFollowing);
        updateNumFollowers(newNumFollowers);
      }
    } catch (error) {
      console.error(`Failed to ${action} organizer:`, error);
    }
  };

  return {
    followActionLoading,
    handleFollowAction,
  };
};

const trackFollowAction = (action: FollowAction, organizerId: string, pageArea?: string) => {
  const followEventName =
    action === FOLLOW_ACTION ? LISTING_HEAP_IDS.FOLLOW_ORGANIZER : LISTING_HEAP_IDS.UNFOLLOW_ORGANIZER;

  track({
    eventName: followEventName,
    eventData: {
      organizerId: organizerId,
      pageArea: pageArea,
    },
  });
};
